enum OssSchemeTypes {
  EU = 4,
  NON_EU = 5,
  IOSS = 6,
}

export const readableSchemeTypes = {
  MOSS: 'EU Scheme',
  VOES: 'Non-EU Scheme',
  IMPORT: 'Import Scheme',
};

export default OssSchemeTypes;
